import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "100",
  height: "100",
  viewBox: "0 0 48 48"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#5c6bc0",
      d: "M41.5 13a3.5 3.5 0 1 0 0 7 3.5 3.5 0 1 0 0-7M4 40l23 4V4L4 8z"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#fff",
      d: "M21 16.27V19l-3.99.18-.02 11.86-2.98-.09V19.29l-4.01.16v-2.51z"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#5c6bc0",
      d: "M36 14c0 2.21-1.79 4-4 4-1.2 0-2.27-.53-3-1.36v-5.28c.73-.83 1.8-1.36 3-1.36 2.21 0 4 1.79 4 4m2 9v11h3.5a3.49 3.49 0 0 0 3.45-3H45v-8zm-9-3v17h3.5a3.49 3.49 0 0 0 3.45-3H36V20z"
    }, null, -1)
  ])))
}
export default { render: render }